import { StyleRules } from '@mui/styles';
import { COLORS } from '../../../constants';

const styles = (): StyleRules => ({
    root: {
        color: COLORS.SECONDARY,
        marginRight: '0.5rem',
    },
    labelRoot: {
        marginLeft: '0',
    },
    checked: {
        color: 'secondary',
    },
    label: {
        fontWeight: 500,
        fontSize: '1rem',
        marginLeft: 0,
        color: COLORS.SECONDARY_LIGHT,
    },
    error: {
        color: COLORS.ERROR,
        marginRight: '0.5rem',
    },
});

export default styles;
